import type { IComponentController, IOnChangesObject, IAugmentedJQuery } from 'angular';
import template from './dashboard-widget.component.html';

import type { WidgetInstance, DashboardService } from '../dashboard.service';
import { DashboardPageController, DashboardConfigurationMode } from '../dashboard-page/dashboard-page.component';

export class DashboardWidgetController implements IComponentController {
	public widgetInstance!: WidgetInstance;
	public serviceContextInfo?: { widgetId: string; viewName: string };
	public page!: DashboardPageController;
	public internalTemplate = '';
	public template?: string;
	public onTitleClick!: (params: { widgetInstance: WidgetInstance }) => void;
	public onSelectItem!: (params: { widgetInstance: WidgetInstance }) => void;

	static $inject = ['$element', 'mx.sb.Dashboard.Service'];
	constructor(
		private readonly $element: IAugmentedJQuery,
		private readonly dashboardService: DashboardService
	) {}

	$onInit() {
		this.setServiceContext(this.widgetInstance);
	}

	$postLink(): void {
		this.$element.on('click', '.highcharts-point', () => {
			if (this.hasDrilldown()) {
				this.onSelectItem({ widgetInstance: this.widgetInstance });
			}
		});
	}

	$onChanges(onChangesObj: IOnChangesObject) {
		if (onChangesObj.widgetInstance || onChangesObj.template) {
			this.internalTemplate = this.template || '';
			this.setServiceContext(this.widgetInstance);
		}
	}

	public get dataModel() {
		return this.widgetInstance?.dataModel;
	}

	private setServiceContext(widgetInstance: WidgetInstance) {
		this.serviceContextInfo = {
			widgetId: widgetInstance.widgetId ?? '',
			viewName: widgetInstance.templateData?.widgetViewKey ?? '',
		};
	}

	public hasDrilldown() {
		return (
			(this.page.configurationMode === DashboardConfigurationMode.Disabled || this.page.embeddedMode) &&
			this.dashboardService.doesWidgetInstanceHaveRelatedDatasetViewNavigation(this.widgetInstance)
		);
	}

	public getWidgetCategoryClassName() {
		return `mx-dashboard-widget__category-${this.dashboardService.categoryIdAlias(this.widgetInstance?.categoryId)}`;
	}

	public getWidgetClassName() {
		return `mx-dashboard-widget___${this.dashboardService.widgetIdAlias(this.widgetInstance?.widgetId)}`;
	}

	public handleTitleClick() {
		this.dashboardService.unsetSelectedItem(this.widgetInstance);
		this.onTitleClick({ widgetInstance: this.widgetInstance });
	}
}

export const DashboardWidgetComponent = {
	name: 'mxDashboardWidget',
	controller: DashboardWidgetController,
	controllerAs: 'vm',
	template,
	bindings: {
		widgetInstance: '<',
		template: '<',
		onEdit: '&',
		onRemove: '&',
		onTitleClick: '&',
		onSelectItem: '&',
		page: '<',
	},
};
